
import { Component, Vue, Watch } from "vue-property-decorator";
import { OrdiniList } from "@/components"
import { Loading, LoadingTemplateType, DatePicker, ItemListVariazioneOrdineMTM, ItemListVariazioneArrayItemsOrdineMTM, ItemListRigaMTM, ItemListMisuraCliente, ItemListMisuraMTM} from "@/components";
import { OrdineMTM, MisuraMTM, RequestAllegatoDownload, AggiornaDatiOrdineFornitoreRigaMTMRequest, AggiornaNoteOrdineFornitoreRigaMTMRequest, ConfermaVariazioneTestataMTMRequest, ConfermaVariazioneTestataArrayItemsRequest, ConfermaVariazioneSubArrayMTMRequest, RigaOrdineMTM } from "@/models";
import { store, StoreActions, StoreMutations } from '@/store';
import saveAs from "file-saver";

@Component({
    components: {
        Loading,
        DatePicker,
        ItemListVariazioneOrdineMTM,
        ItemListVariazioneArrayItemsOrdineMTM,
        ItemListRigaMTM,
        ItemListMisuraCliente,
        ItemListMisuraMTM,
        OrdiniList
    }
})
export default class OrdineMTMDettaglio extends Vue {
    private showVariazioniTestata: boolean = false;
    private showVariazioniArrayItemsRigheMtm: boolean = false;
    private showVariazioniArrayItemsMisureMtm: boolean = false;
    private showVariazioniArrayItemsMisureCliente: boolean = false;
    private showVariazioniArrayItemsAllegatiCliente: boolean = false;
    private showVariazioniArrayItemsAllegatiOrdine: boolean = false;

    async confermaVariazioneTestata(id: string){
        let request: ConfermaVariazioneTestataMTMRequest = {
            idOrdine: this.ordine?.id || "",
            idVariazione: id,
            idFornitore: this.ordine?.fornitore ?? ""
        };

        await store.dispatch(StoreActions.ConfermaVariazioneTestataOrdineMTM, request);
    }

    async confermaVariazioneArrayItems(id: string, property: string){
        let request: ConfermaVariazioneTestataArrayItemsRequest = {
            idOrdine: this.ordine?.id || "",
            idVariazione: id,
            idFornitore: this.ordine?.fornitore ?? "",
            property: property
        };

        await store.dispatch(StoreActions.ConfermaVariazioneArrayItemsOrdineMTM, request);
    }

    async confermaVariazioneSubArray(request: ConfermaVariazioneSubArrayMTMRequest, subArrayName: string){
        request.idOrdine = this.ordine?.id || "";
        request.idFornitore = this.ordine?.fornitore || "";
        request.subArrayName = subArrayName;

        await store.dispatch(StoreActions.ConfermaVariazioneSubArrayOrdineMTM, request);
    }
    get ordine(): OrdineMTM | undefined {
        return store.state.ordineMTMCorrente;
    }

    get idRiga(): string | null | undefined{
        return store.state.uiOrdiniMTM.idRiga;
    }

    get idLidAssociata(): string | null | undefined{
        return store.state.uiOrdiniMTM.idLidAssociata;
    }

    get displayAllegati(): boolean{
        let currOrdine = store.state.ordineMTMCorrente;
        if(currOrdine){
         return (currOrdine.allegatiOrdine?.length > 0 ?? false) ||
            (currOrdine.allegatiCliente?.length > 0 ?? false);
        } else {
            return false;
        }
    }
    get displayAllegatiOrdine(): boolean{
        let currOrdine = store.state.ordineMTMCorrente;
        if(currOrdine){
         return currOrdine.allegatiOrdine?.length > 0 ?? false;
        }else{
            return false;
        }
    }
    get displayAllegatiCliente(): boolean{
        let currOrdine = store.state.ordineMTMCorrente;
        if(currOrdine){
         return currOrdine.allegatiCliente?.length > 0 ?? false;
        }else{
            return false;
        }
    }

    private buttonDownloadIsLoading(id: number){
        return store.state.uiOrdiniMTM.downloadButtonLoading == id;
    }

    get orderedMisureMTM() : MisuraMTM[]
    {
        if(store.state.ordineMTMCorrente?.misureMtm) {
            const ordered = store.state.ordineMTMCorrente?.misureMtm.sort((a,b) => {
                if(parseInt(a.ordine) > parseInt(b.ordine)) return 1;
                if(parseInt(a.ordine) < parseInt(b.ordine)) return -1;
                return 0;
            });
            return ordered;
        }
        return [];
    }

    get misurePerTipo(): Map<string, {items: MisuraMTM[], hasVariazioni: boolean}> {
        if(this.orderedMisureMTM.length > 0) {
            let res = this.orderedMisureMTM.reduce((acc: Map<string, {items: MisuraMTM[], hasVariazioni: boolean}>, obj) => {
                let key = obj.tipoMisura;
                if (!acc.has(key)) {
                    acc.set(key, {items: [], hasVariazioni: false});
                }
                var o = acc.get(key);
                if(o) o.hasVariazioni = o.hasVariazioni || obj.variazioni?.length > 0;
                if(o?.items && (obj.totale || obj.variazione))
                    o.items.push(obj);
                return acc;
            }, new Map<string, {items: MisuraMTM[], hasVariazioni: boolean}>());

            return res;
        }
        return new Map<string, {items: MisuraMTM[], hasVariazioni: boolean}>();
    }

    get loadTemplateCorrente() : LoadingTemplateType {
        return LoadingTemplateType.OrdineDettaglio
    }

    get showDatiFornitoreSendReminder() : boolean{
        if(this.ordine && this.ordine.stato == "INVIATO"){
            if(this.ordine.righeMtm.some(r => !r.dataConsegnaFornitore &&
                !r.idOrdineFornitore &&
                !r.dataConsegnaFornitoreDaAggiornareAs400 &&
                !r.idOrdineFornitoreDaAggiornareAs400 &&
                !r.dataConsegnaFornitoreDaAggiornareAs400)){
                return true;
            } else{
                return false;
            }
        } else {
            return false;
        }
    }
    get righeDatiFornitoreToSend() : RigaOrdineMTM[]{
        if(this.ordine)
        {
            const sum = this.ordine.righeMtm.filter(r => !r.dataConsegnaFornitore &&
                !r.idOrdineFornitore &&
                !r.dataConsegnaFornitoreDaAggiornareAs400 &&
                !r.idOrdineFornitoreDaAggiornareAs400 &&
                !r.dataConsegnaFornitoreDaAggiornareAs400
            );
            return sum;
        } else {
            return [];
        }
    }

    @Watch("$route.params.id", { immediate: true })
    async onIdChanged(newId: string, oldId: string) {
        store.commit(StoreMutations.SetSottotitoloPagina, newId);
        await store.dispatch(StoreActions.GetOrdineMTM, newId);
        if(this.ordine) {
            store.dispatch(StoreActions.OperazioniEtichetteDremeDisponibiliPerOrdine, newId);
            store.dispatch(StoreActions.GetResetEPCDisponibile);
            store.dispatch(StoreActions.GetStampaEtichetteRfidDisponibile);
            store.dispatch(StoreActions.GetStampaEtichetteNoRfidDisponibile);
            // TODO?
        }
    }

    @Watch("$route.params.idRiga", { immediate: true })
    async onIdRigaChanged(newId: string, oldId: string) {
        store.commit(StoreMutations.SetIdRigaOrdineMTM, newId);
    }

    @Watch("$route.params.idLavorazioneAssociata", { immediate: true })
    async onIdLidAssociataChanged(newId: string, oldId: string) {
        store.commit(StoreMutations.SetLidAssociataARigaOrdineMTM, newId);
    }

    get loading() {
        return store.state.loading;
    }

    private async downloadAllegato(id: number, nomeFile:string, fornitore: string){

        let request : RequestAllegatoDownload = {
            idAllegato: id,
            fornitore: fornitore
        }

        let data = await store.dispatch(StoreActions.DownloadAllegato, request);
        if(data){
            saveAs(data, nomeFile);
        }
    }

    private async inviaDatiOrdineConsegnaRigaMtm(request: AggiornaDatiOrdineFornitoreRigaMTMRequest){
        request.idFornitore = this.ordine?.fornitore ?? "";
        await store.dispatch(StoreActions.InviaAggiornaDatiOrdineFornitoreRigaMtm, request);
    }

    private async inviaNoteConsegnaRigaMtm(request: AggiornaNoteOrdineFornitoreRigaMTMRequest){
        request.idFornitore = this.ordine?.fornitore ?? "";
        await store.dispatch(StoreActions.InviaAggiornaNoteConsegnaRigaMtm, request);
    }

    // STAMPA ETICHETTE
    stampaEtichettePerOrdine(operazione: string) {
        var asd = store.state.ordineMTMCorrente;
        store.dispatch(StoreActions.StampaEtichettePerOrdineMTM, { operazione: operazione, idOrdine: store.state.ordineMTMCorrente?.id });
    }

    get canResetEPC(): boolean {
        return store.state.uiOrdine.stampaEtichette.resetEpcDisponibile;
    }

    get canPrintEtichette(): boolean {
        return store.state.uiOrdine.stampaEtichette.stampaDisponibile;
    }

    get stampaEtichetteRfidDisponibile() : boolean {
        return store.state.stampaEtichetteRfidDisponibile;
    }

    get stampaEtichetteNoRfidDisponibile() : boolean {
        return store.state.stampaEtichetteNoRfidDisponibile;
    }

    get isStampaEtichettaLoading(): boolean{
        return store.state.uiLavorazione.stampaEtichette.loading;
    }
    
}
